<template>
	<div class="mobile">
		<van-nav-bar class="userNavBar" @click-left="onClickLeft" title="自选课程" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<div class="mobile-study">
			<van-list v-if="courseTotal > 0">
				<van-cell class="list" v-for="item in courseList" :key="item.id">
					<div style="display: flex">
						<div class="mobile-study-pic">
							<img class="cover" :src="item.pictureShowUrl" alt />
						</div>
						<div>
							<div class="mobile-study-title">
								{{ item.goodsName }}
							</div>
							<div class="textImage_he">
								<span class="period"> 考核学时:{{ item.testHours }} </span>
							</div>
						</div>
					</div>
					<div style="display: flex; align-items: baseline">
						<!-- 进度条 -->
						<div class="progress" style="display: flex; align-items: center">
							<van-progress
								:show-pivot="false"
								style="width: 3.68rem"
								:percentage="(parseFloat(item.studyPercent)*100)"
								stroke-width="4"
								track-color="#e1e1e1"
								color="#dc0021"
							/><span>已学{{ parseFloat(item.studyPercent)*100 }}%</span>
						</div>
						<div class="mobile-study-btn">
							<van-button
								round
								size="small"
								v-if="item.studyStatus == '039001'"
								type="danger"
								:to="{
									path: '/mobileCourseDetail',
									query: {
										id: item.goodsId,
										actives: 2,
									},
								}"
								>开始学习</van-button
							>
							<van-button
								round
								size="small"
								v-if="item.studyStatus == '039002'"
								type="danger"
								:to="{
									path: '/mobileCourseDetail',
									query: {
										id: item.goodsId,
										actives: 2,
									},
								}"
								>继续学习</van-button
							>
							<van-button
								round
								size="small"
								v-if="item.studyStatus == '039003'"
								type="danger"
								:to="{
									path: '/mobileCourseDetail',
									query: {
										id: item.goodsId,
										actives: 2,
									},
								}"
								>已学完</van-button
							>
						</div>
					</div>
				</van-cell>
			</van-list>
			<van-list class="custom-class-image" v-else>
				<van-empty class="custom-image" image="../../../static/images/mobile/noclass.png" description="暂无课程" />
			</van-list>
		</div>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: 2,
			actives: 0,
			courseList: [],
			pageNumber: 1,
			pageSize: 10,
			types: "016003,016004",
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
			courseTotal: "",
		};
	},
	methods: {
		classList() {
			let userId = this.$sessionStore.getUserId();
			let pageSize = this.pageSize;
			let pageNumber = this.pageNumber;
			let types = this.types;
			let params = {};
			params.userId = userId;
			params.pageSize = pageSize;
			params.pageNumber = pageNumber;
			params.types = types;
			this.$axiosPackag.getMessageByAxios("GET", "/userStudyResource/myStudyData", params, null, null, (resD) => {
				if (resD) {
					this.courseList = resD.rows;
					this.courseTotal = this.courseList.length;
					//登录数据设置
                    if (!userId){
                        this.$axiosPackag.getMessageByAxios(
                            "GET",
                            "/session/getSession",
                            null,
                            null,
                            null,
                            (resD) => {
                                if (resD) {
                                    this.$sessionStore.initSession(resD);
                                }
                            }
                        );
                    }
				}
			});
		},
		cannelGoBack() {
			this.$router.go(-1);
		},
		onClickLeft() {
			this.$router.go(-1);
		},
	},
	components: {},
	mounted() {},
	created() {
		this.classList();
	},
	beforeCreate() {
		document.querySelector("body").setAttribute("style", "background:#eee");
	}, //
	beforeDestroy() {
		document.querySelector("body").removeAttribute("style");
	},
};
</script>

<style scoped>
.body {
	background-color: #f2f2f2;
}
.cover {
	width: 2.826667rem;
	height: 1.6rem;
}
.mobile-study .list {
	box-shadow: 0rem 0.16rem 0.533333rem rgba(216, 216, 216, 0.49);
}
.mobile-study .mobile-study-title {
	margin: 0.426667rem 0.426667rem 0.266667rem 0.426667rem;
	font-weight: bold;
	font-size: 0.426667rem;
}
.textImage_he {
	margin-left: 0.426667rem;
}
.mobile-study-btn {
	margin-top: 0.133333rem;
	margin-bottom: 0.426667rem;
}
.mobile-study-btn .van-button {
	width: 2.346667rem;
	height: 0.853333rem;
}
.mobile-study-btn .van-button:first-child {
	margin-left: 0.426667rem;
	margin-right: 0.45rem;
}
.mobile-study-btn .van-button:nth-child(2) {
	margin-right: 0.45rem;
}
.progress {
	margin-left: 0.426667rem;
}
.progress span {
	font-size: 0.32rem;
	margin-left: 0.106667rem;
}
.mobile-study-pic {
	margin-left: 0.426667rem;
	margin-top: 0.426667rem;
}
.list:last-child {
	padding-bottom: 5rem;
}
.mobile-study {
	padding-bottom: 2rem;
}
</style>


// WEBPACK FOOTER //
// MobileClassRoom.vue?9efacc24